import { render, staticRenderFns } from "./ProductEditDialog.vue?vue&type=template&id=5f23207f&scoped=true&"
import script from "./ProductEditDialog.vue?vue&type=script&lang=js&"
export * from "./ProductEditDialog.vue?vue&type=script&lang=js&"
import style0 from "./ProductEditDialog.vue?vue&type=style&index=0&id=5f23207f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f23207f",
  null
  
)

export default component.exports